module.exports = __webpack_public_path__ + "static/media/error-test-notification.53d59d7d.svg";